import options from './block-loader.directive';

export default {
    selector: 'dtBlockLoader',
    options
};



// WEBPACK FOOTER //
// ./app/common/block-loader/index.js